import { useMemo, useState, useEffect, useContext } from 'react'
import moment from 'moment-timezone'
import { useTheme } from '@mui/material/styles'
import { createTableStyles } from '../table-styles'
import StyledPaper from '../paper.jsx'

import { IconButton, Button, Box, Tooltip } from '@mui/material'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'

import {
  MaterialReactTable,
  useMaterialReactTable,
  MRT_ToggleDensePaddingButton,
  MRT_ShowHideColumnsButton,
  MRT_ToggleFullScreenButton,
  MRT_ToggleFiltersButton,
  MRT_ToggleGlobalFilterButton
} from 'material-react-table'

import { AppContext } from '/providers/app-context'
import { getTemplateData } from '/providers/templates-api'

import SaveAltIcon from '@mui/icons-material/SaveAlt'
import DataExportDialog from "../data-export-dialog"
import excelExport from './notifications-list-to-excel'
import NotifySelectedDialog from './notify-selected-dialog'

const NotificationsTable = ({ templateId, passId, data, loading, refreshNotifications }) => {

  const theme = useTheme()
  const tableStyles = useMemo(() => createTableStyles(theme), [theme])


  const { apiSource, apiKeys } = useContext(AppContext)

  const [dataExportDialogOpen, setDataExportDialogOpen] = useState(false)
  const [openNotify, setOpenNotify] = useState(false)
  const [template, setTemplate] = useState()

  useEffect(() => {
    getTemplate()
  }, [templateId])

  const getTemplate = async () => {
    const t = await getTemplateData({ apiSource, apiKeys, templateId })
    if (!t.error) setTemplate(t.template)
    // TODO handler error
  }

  const columns = useMemo(() => [
    {
      id: 'ts',
      accessorFn: (originalRow) => moment(originalRow.ts, "YYYYMMDDHHmmSS"),
      header: 'Created',
      filterVariant: 'date-range',
      sortingFn: 'datetime',
      size: 200,
      Cell: ({ cell }) => cell.getValue().format("DD MMM YYYY HH:mm")
    },
    {
      accessorKey: 'message',
      header: 'Message',
      filterVariant: 'autocomplete',
      size: 800,
    },
  ])

  const table = useMaterialReactTable({
    columns,
    data,
    state: {
      isLoading: loading,
    },
    initialState: { showColumnFilters: false },
    enablePagination: false,
    enableBottomToolbar: false,
    enableRowSelection: false,
    enableMultiRowSelection: false,
    enableRowActions: false,
    enableStickyHeader: true,
    enableStickyFooter: true,
    positionToolbarAlertBanner: "none",
    getRowId: (originalRow) => originalRow.pass_id,
    ...tableStyles,
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        <MRT_ToggleGlobalFilterButton table={table} />
        <MRT_ToggleFiltersButton table={table} />
        <MRT_ShowHideColumnsButton table={table} />
        <MRT_ToggleDensePaddingButton table={table} />
        <MRT_ToggleFullScreenButton table={table} />
        <Tooltip title="Export"><IconButton onClick={() => setDataExportDialogOpen(true)}><SaveAltIcon /></IconButton></Tooltip>
      </Box>
    ),
    renderTopToolbarCustomActions: () => (
      <div className='flex flex-row gap-5'>
        <Button onClick={() => setOpenNotify(true)} className='link'><EmailOutlinedIcon className='mr-2' /> Send Notification</Button>
      </div>
    )
  })

  return (
    <Box sx={{ height: 'calc(100vh - 185px)', width: '100%', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <StyledPaper sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }} height="100vh">
        <MaterialReactTable table={table} />
        <DataExportDialog open={dataExportDialogOpen} setOpen={setDataExportDialogOpen} fileName={`${templateId}-(${passId})-notifications`} data={data} excelExport={excelExport} />
        <NotifySelectedDialog open={openNotify} setOpen={setOpenNotify} template={template} passes={[passId]} refresh={refreshNotifications} />
      </StyledPaper>
    </Box>)
}

export default NotificationsTable